import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';

import history from '../../../history';

function isLeftClickEvent(event) {
    return event.button === 0;
}

function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

class DropdownNavLink extends React.Component {

    handleClick = (event) => {
        const { noLink } = this.props;

        if (this.props.onClick) {
            this.props.onClick(event);
        }

        if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
            return;
        }

        if (event.defaultPrevented === true) {
            return;
        }

        event.preventDefault();

        if (!noLink) {
            history.push(this.props.to);
        }
    };

    render() {
        const { to, children, className } = this.props;
        return <Dropdown.Item href={to} onClick={this.handleClick} className={className}>{children}</Dropdown.Item>;
    }
}

export default DropdownNavLink;
